// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8351137e","885":"9e60b6ad","977":"afd04547"}[chunkId] + ".chunk.js";
};